// Imports ------------------------------------------------------------------->

import { Component } from '../Component'
import { element } from '../CustomElement'

import { inject } from '../../services/di'
import { AuthenticationService } from '../../services/AuthenticationService'
import { ConfigService } from '../../services/ConfigService'
import { icons } from '../../icons/Icons'
import { i18n } from '../../i18n/I18n'
import { Link } from '../flipp-link/Link'
import { LinkService } from '../../services/LinkService'
import { FormInput } from '../flipp-form-input/FormInput'
import {
    EMAIL_REGEXP,
    handleFormInputsChange,
    handleSubmitRequest,
    setDocumentTitle,
} from './Login.helper'

@element('flipp-forgot-password-page')
export class ForgotPasswordPage extends Component<any, void> {
    @inject config: ConfigService
    @inject auth: AuthenticationService

    refs: {
        submitForm: HTMLFormElement
        submitBtn: HTMLElement
        spinner: HTMLElement
        submitBtnText: HTMLElement
        emailInput: FormInput
        responseErrorMsg: HTMLElement
    }

    state = {
        email: '',
    }

    onCreate() {
        setDocumentTitle(i18n('forgot_password_header'))
    }

    onAttach() {
        this.state.email = ''
    }

    render() {
        return (
            <main>
                <div class="top-bar">
                    <Link to="listing" class="flipp-logo" title="Flipp">
                        {icons.flippLogoWhite}
                    </Link>
                </div>
                <div class="one-column-content">
                    <div class="one-column-picture">
                        <img
                            src={`https://f.wishabi.net/creative/Distribution/images/reset-password.svg`}
                            alt=""
                        />
                    </div>
                    <div class="header">{i18n('forgot_password_header')}</div>
                    <div class="one-column-text">
                        {i18n('forgot_password_text')}
                    </div>
                    <div class="one-column-form">
                        <form name="submitForm" ref="submitForm">
                            <FormInput
                                ref="emailInput"
                                name={'email'}
                                handleChange={this.handleChange}
                                type={'email'}
                                placeholder={i18n('email')}
                            />
                            <div class="button-container">
                                <button
                                    ref="submitBtn"
                                    class="flipp-button"
                                    onClick={this.handleSubmit}
                                >
                                    <div
                                        ref="spinner"
                                        class="spinner hide"
                                    ></div>
                                    <div
                                        ref="submitBtnText"
                                        class="submit-button-text"
                                    >
                                        {i18n('forgot_password_send_code')}
                                    </div>
                                </button>
                                <p ref="responseErrorMsg" class="error-msg"></p>
                            </div>
                        </form>
                    </div>
                </div>
            </main>
        )
    }

    private sendPasswordResetCode = async () => {
        await this.auth.sendPasswordResetCode(this.state.email)
        const linkService = LinkService.getInstance()
        const uri = `confirm_change_password?email=${encodeURIComponent(this.state.email)}`
        linkService.execute(uri, this)
    }

    private handleChange = (e: any) => {
        this.state = handleFormInputsChange(this.state, this.refs, e)
    }

    private handleSubmit = async (e: any) => {
        e.preventDefault()
        this.refs.responseErrorMsg.textContent = ''
        if (this.state.email.length === 0) {
            this.refs.emailInput.errorMessage = i18n('enter_email_error')
        } else if (!EMAIL_REGEXP.test(this.state.email)) {
            this.refs.emailInput.errorMessage = i18n(
                'enter_invalid_email_error'
            )
        } else {
            await handleSubmitRequest(
                this.refs,
                this.sendPasswordResetCode,
                (body) => {
                    if (body.code === 'USER_NOT_CONFIRMED') {
                        this.refs.responseErrorMsg.textContent =
                            i18n('USER_NOT_CONFIRMED')
                    }
                }
            )
        }
    }
}
